import { Loader } from '@/ui'
import React from 'react'

const LoadingModal = ({ title, message }) => {
  return (
    <div className="tw-fixed tw-inset-0 tw-z-[10000] tw-grid tw-place-items-center tw-bg-white/60 tw-backdrop-blur-sm">
      <div className="tw-rounded  tw-px-4 tw-py-2">
        <Loader text={title} className="tw-z-50" />
        {message && (
          <span className="tw-text-sm tw-text-content-base">{message}</span>
        )}
      </div>
    </div>
  )
}

export default LoadingModal
